__turbopack_context__.v({
  "bottom": "Image-module-scss-module__6GtkCq__bottom",
  "fade-in": "Image-module-scss-module__6GtkCq__fade-in",
  "image": "Image-module-scss-module__6GtkCq__image",
  "imageInner": "Image-module-scss-module__6GtkCq__imageInner",
  "isForward": "Image-module-scss-module__6GtkCq__isForward",
  "middle": "Image-module-scss-module__6GtkCq__middle",
  "prev": "Image-module-scss-module__6GtkCq__prev",
  "root": "Image-module-scss-module__6GtkCq__root",
  "swipe-off-left": "Image-module-scss-module__6GtkCq__swipe-off-left",
  "swipe-off-right": "Image-module-scss-module__6GtkCq__swipe-off-right",
  "top": "Image-module-scss-module__6GtkCq__top",
});
